import env from "Consts/env";
import { apiSlice } from "../api/apiSlice";

export const brandsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getListBrands: builder.query({
			query: (args) => {

				const { isDirect } = args.params;

				const isDirectBoolean = !!isDirect;

				const baseURL = isDirectBoolean
					? `${process.env.NEXT_PUBLIC_MAGENTO_BS}/magento/brand`
					: "/api/fds-brands";

				return {
					url: baseURL,
					headers: {
						...env.HEADERS,
						...args?.headers,
					},
					params: {
						...args.params,
					},
					validateStatus: (response) => response.status === 304
						|| (response.status >= 200 && response.status < 300)
					,
				};

			},
			// providesTags: ["Products"],
		}),
	}),
});

export const {
	useGetListBrandsQuery,
} = brandsApiSlice;
